import Vue from 'vue'
import Dialog from './Dialog.vue'
import DialogPay from './DialogPay.vue'
import DialogLogin from './DialogLogin.vue'
import DialogLink from './DialogLink.vue'
import DialogXdCost from './DialogXdCost.vue'
import DialogBankPay from './DialogBankPay.vue'
/**
 * 删除所有的dialog，在切换路由时用到
 */
function close () {
  document.body
    .querySelectorAll('.eqc-dialog-base')
    .forEach(dom => dom.remove())
}

/**
 * 通用打开窗口
 * @param {Object} options
 */
function open (options) {
  let defaultOptions = {
    component: null,
    data: null,
    params: {}
  }
  options = Object.assign(defaultOptions, options)

  return new Promise((resolve, reject) => {
    let UiDialog = Vue.extend(Dialog)
    let vm = new UiDialog({
      components: {
        cDialog: options.component
      },
      propsData: { data: options.data, params: options.params },
      destroyed () {
        // eslint-disable-next-line
        this.value ? resolve(JSON.parse(JSON.stringify(this.value))) : reject()
      }
    }).$mount()
    document.body.appendChild(vm.$el)
  })
}

/**
 * 打开支付框
 * @param {Object} data
 */
function openPay (data) {
  return open({
    component: DialogPay,
    data
  })
}

/**
 * 打开登录框
 * @param {Object} data
 */
function openLogin (data) {
  return open({
    component: DialogLogin,
    data
  })
}
/**
 * 打开登录框
 * @param {Object} data
 */
function openLink (data) {
  return open({
    component: DialogLink,
    data
  })
}

/**
 * 打开秀点支付
 * @param {Object} data
 */
function openXdCost (data) {
  return open({
    component: DialogXdCost,
    data
  })
}

/**
 * 打开对公支付
 * @param {Object} data
 */
function openBankPay (data) {
  return open({
    component: DialogBankPay,
    data
  })
}

function install (Vue) {
  Vue.dialog = Vue.prototype.dialog = {
    close,
    open,
    openPay,
    openLogin,
    openLink,
    openXdCost,
    openBankPay
  }
}

Vue.use(install)

export default install
